import PropTypes from "prop-types";
import {cuppa, log, val} from "../../../../cuppa/cuppa";
import {useEffect, useRef} from "react";

export const InputTextTypes = {NUMBER:'NUMBER', PHONE:'PHONE', MONEY:'MONEY', COMMENT:'COMMENT', EMAIL:'EMAIL', PASSWORD:'PASSWORD', SEARCH:'SEARCH', SEND:'SEND', RICHTEXT:'RICHTEXT', RANGE:'RANGE'}
export function InputText(props){
	const inputText = useRef();

	useEffect(()=>{
		if([InputTextTypes.NUMBER, InputTextTypes.MONEY].indexOf(props.type) !== -1){
			new cuppa.inputFilter(inputText.current, '0-9.');
		}else if(props.type === InputTextTypes.PHONE){
			new cuppa.inputFilter(inputText.current, '0-9() \+\-');
		}else if(props.type === InputTextTypes.RICHTEXT){
			setRichEditor().then()
		}
		if(props.type !== InputTextTypes.COMMENT) cuppa.keyEnter(inputText.current, ()=>{ });
		if(props.initialTrigger) onChange(props.value);
		if(props.autoHeight) setAutoHeight();
	}, []);

	function setAutoHeight(){
		if(!inputText.current) return;
		inputText.current.style.minHeight = 0;
		inputText.current.style.height = 'auto';
		inputText.current.style.padding = '5px 10px';
		inputText.current.style.overflow = 'hidden';
		inputText.current.oninput = (e)=>{
			inputText.current.style.minHeight = 0;
			inputText.current.style.minHeight = `${e.target.scrollHeight + 5}px`;
		}
	}

	async function setRichEditor(){
		if(!inputText?.current) return;
		let config = {
			autoGrow: false,
			toolbar: [ 'heading', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
			heading: {
				options: [
					{ model: 'paragraph', title: 'Paragraph', class: 'e-p' },
					{ model: 'heading1', view: 'h1', title: 'Heading 1', class: 'editor-h1' },
					{ model: 'heading2', view: 'h2', title: 'Heading 2', class: 'editor-h2' },
				]
			},
		}

		let richEditor = inputText.current.editor = await window["ClassicEditor"].create(inputText.current, config);
		richEditor.setData(cuppa.htmlEntitiesDecode(props.value) || '');
		richEditor.model.document.on('change:data', ()=>{
			let text = richEditor.getData();
			onChange(text)
		});
		richEditor.editing.view.document.on('blur', () => {
			let text = richEditor.getData();
			if(props.onBlur){
				props.onBlur(text);
			}
		});
	}

	function onChange(value){
		if(props.type === InputTextTypes.PHONE){
			value = value.replaceAll('.', '');
			value = value.replaceAll(',', '');
		}
		if(props.callback) props.callback(value);
	}

	let value = props.value || '';
	let inputStyle = props.inputStyle;
	if(props.type === InputTextTypes.RANGE){
		inputStyle = {...inputStyle, ...{boxShadow:'none', padding:0}}
	}
	if(props.resizable){
		inputStyle = {...{resize:'vertical'}, ...inputStyle}
	}
	return(
		<>
			<div className={`flex d-row m-w-9999 ${props.className} ${props.disabled ? 'disabled' : null}`} id={props.id}
			     style={props.style}>
				{props?.type === InputTextTypes.MONEY && props.showIcon && (
					<div className={'button1 button-icon w-auto b-radius-right-0 d-i'}>{props?.sign}</div>
				)}
				{props?.type === InputTextTypes.PHONE && props.showIcon && (
					<div className={'button1 button-icon w-auto b-radius-right-0 d-i'}>
						<i className="fa fa-phone fa-rotate-90" aria-hidden="true"></i>
					</div>
				)}
				{props?.type === InputTextTypes.EMAIL && props.showIcon && (
					<div className={'button1 button-icon w-auto b-radius-right-0 d-i'}>
						<i className="fas fa-envelope"></i>
					</div>
				)}
				{props?.type === InputTextTypes.COMMENT ? (
					<textarea
						ref={inputText}
						className={'input1 flex-1'}
						value={value}
						onChange={(e) => {
							onChange(e.target.value)
						}}
						onBlur={(e) => {
							if (props.onBlur) props.onBlur(value);
						}}
						style={{...{height: 80, resize: 'none'}, ...inputStyle}}
						disabled={props.disabled}
						placeholder={props.placeholder}
						name={props.name}
					/>
				) : props?.type === InputTextTypes.RICHTEXT ? (
					<div ref={inputText} className="rich-editor-target"></div>
				) : (
					<input
						ref={inputText}
						value={value}
						className={`input1 flex-1 ${[InputTextTypes.MONEY, InputTextTypes.PHONE, InputTextTypes.EMAIL].indexOf(props.type) != -1 && props.showIcon ? `b-radius-left-0` : ''}`}
						onChange={(e) => {
							onChange(e.target.value);
						}}
						onBlur={(e) => {
							if (props.onBlur) props.onBlur(value);
						}}
						type={(props.type === InputTextTypes.EMAIL) ? 'email' : (props.type === InputTextTypes.PASSWORD) ? 'password' : (props.type === InputTextTypes.RANGE) ? 'range' : 'text'}
						disabled={props.disabled}
						style={inputStyle}
						placeholder={props.placeholder}
						name={props.name}
						maxLength={(props.type === InputTextTypes.PHONE) ? 20 : props.maxLength}
						min={props.min}
						max={props.max}
					/>
				)}
				{props?.type === InputTextTypes.SEARCH && props.showIcon && (
					<button
						className={'button1 button-icon w-auto b-radius-left-0 '}
						onClick={(e) => {
							if (props.iconCallback) props.iconCallback(props.value);
						}}
					>
						<i className="fa fa-search" aria-hidden="true"></i>
					</button>
				)}
				{props?.type === InputTextTypes.SEND && props.showIcon && (
					<button
						className={'button1 button-icon w-auto b-radius-left-0 '}
						onClick={(e) => {
							if (props.iconCallback) props.iconCallback(props.value);
						}}
					>
						<i className="fas fa-paper-plane"></i>
					</button>
				)}
				{props.showButton && (
					<button
						className={'button1 button-icon w-auto b-radius-left-0 '}
						style={props.buttonStyle}
						onClick={(e) => {
							if (props.iconCallback) props.iconCallback(props.value);
						}}
					>
						{props.buttonContent || null}
					</button>
				)}
			</div>
			{cuppa.boolean(props.rangeLabels?.length) && (
				<div className={'flex d-row j-between w-100p m-t-20-'}>
					{props.rangeLabels.map(label=>{
						return <label className={'f-12'} key={label}>{label}</label>
					})}
				</div>
			)}
		</>
	)
}

InputText.propTypes = {
	value: PropTypes.any,
	callback: PropTypes.func,
	type: PropTypes.string,
	sign: PropTypes.string,
	style: PropTypes.object,
	inputStyle: PropTypes.object,
	className: PropTypes.string,
	onBlur: PropTypes.func,
	id: PropTypes.string,
	initialTrigger: PropTypes.bool,
	disabled: PropTypes.bool,
	showIcon: PropTypes.bool,
	placeholder: PropTypes.string,
	name: PropTypes.string,
	iconCallback: PropTypes.func,
	maxLength: PropTypes.number,
	showButton: PropTypes.bool,
	buttonContent: PropTypes.any,
	buttonStyle: PropTypes.object,
	autoHeight: PropTypes.bool,
	min: PropTypes.number,
	max: PropTypes.number,
	rangeLabels: PropTypes.array,
	resizable:PropTypes.bool,
};
InputText.defaultProps = {
	value: '',
	callback: null,
	type: '',
	sign: '$',
	style: null,
	inputStyle: null,
	className: '',
	onBlur: null,
	id: null,
	initialTrigger: false,
	disabled: false,
	showIcon: true,
	placeholder: '',
	name: '',
	iconCallback: null,
	maxLength: null,
	showButton: false,
	buttonContent: null,
	buttonStyle: null,
	autoHeight: false,
	min: null,
	max: null,
	rangeLabels: null,
	resizable:false,
};
